import React from 'react';

import {observer} from 'mobx-react';
import classNames from "classnames";
import {GroupEntityHeader} from "../../entity-header/group-entity-header";
import {TAG_TITLE} from "../../../app/consts";

export const BaseMainTitle = observer(({controller, title, subTitle, entity, className, source, TitleTag = TAG_TITLE.div}) => {
  const entityProps = {
    entity,
    title,
    subTitle,
    className,
    controller,
    source
  }

  return entity ? <GroupEntityHeader {...entityProps}/> : <TitleTag className={classNames(className)}>{title}</TitleTag>;
});

